import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { from, iif, Observable } from "rxjs";
@Injectable({
  providedIn: "root",
})
export class MailService {
  constructor(private http: HttpClient) {}

  onSendService(fromData: FormData): Observable<any> {
    return this.http.post<any>(
      "https://www.ucn.edu.ni/services/notifications/index.php",
      fromData
    );
  }
  
  ///la confirmacion se envia junto con el archivo
  onSendServiceConfirmation(fromData: FormData): Observable<any> {
    return this.http.post<any>(
      "https://www.ucn.edu.ni/services/notifications/confirmation.php",
      fromData
    );
  }
}
